<template>
  <div class="card border-0 no-shadow bg-light mb-3">
    <div class="card-header border-0 bg-transparent">
      <h5 class="card-title">อัปโหลดรูปบัตรประชาชน</h5>
      <br />
      <ImgUpload
        title="บัตรประชาชน"
        :endpoint="`/companies/${comId}/members/${mId}/images/id-card`"
        :config="idConfig"
        :path="card"
        :base="baseUrl"
        :src="`${baseUrl}/${card}?token=${token}`"
        :fd="idFd"
        imgFormName="idCard"
        @success="onUploaded"
      />
      <br /><br />
    </div>
  </div>
</template>

<script>
// Slim ID-card upload for the Wannasorn edit page (รูปสำหรับยืนยันตัวตน tab). Reuses the shared
// ImgUpload widget + file-access service, mirroring the ID-card section of ImgUploadTab.vue.
import ImgUpload from "./ImgUpload";
import api from "@/services/api.js";

export default {
  components: { ImgUpload },
  data() {
    return {
      token: localStorage.getItem("token"),
      mId: this.$route.params.id,
      comId: localStorage.getItem("ComId"),
      baseUrl:
        process.env.VUE_APP_FILE_REC_ACCESS_SERVICE_URL ||
        "https://cs-file-access-service-20220905.coursesquare.com",
      idConfig: {
        "content-type": "multipart/form-data",
        token: localStorage.getItem("token"),
      },
      card: null,
      idFd: new FormData(),
    };
  },
  mounted() {
    this.getId();
  },
  methods: {
    onUploaded(input) {
      this.update(input.value.idCardPath);
    },
    async update(idCardPath) {
      await api
        .post(`/v1/update-id-path/${this.mId}`, { idPath: idCardPath })
        .then(() => {
          this.getId();
        });
    },
    async getId() {
      await api.get(`v1/members/${this.mId}`).then(({ data }) => {
        const profile = data.data.profiles.find(
          (profile) => profile.company.id == this.comId
        );
        this.card = profile ? profile.idPath : null;
      });
    },
  },
};
</script>
